import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon, StarRating, TripadvisorRatingIcon } from "@b2bportal/core-ui";
import type { LodgingData } from "@b2bportal/lodging-api";
import { useHotelInfoSection } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./HotelInfoSection.module.scss";

export interface HotelInfoSectionProps extends PlatformComponentProps {
  hotelData: LodgingData;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelInfoSection;

export const HotelInfoSection = (props: HotelInfoSectionProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, text } = useHotelInfoSection(props);

  return (
    <div className={clsx(block, className)}>
      <h1 className={cn("name")}>{text.hotelName}</h1>
      <div className={cn("hotel-ratings")}>
        <StarRating starRating={context.starRating} />
      </div>
      {context.overallRating != null ? (
        <div className={cn("tripadvisor-ratings")}>
          <Icon
            className={cn("tripadvisor-icon")}
            iconName={IconNameEnum.tripadvisor}
          />
          <TripadvisorRatingIcon scoreOutOfFive={context.overallRating} />
          {text.reviewCount}
        </div>
      ) : null}
      <div className={cn("address-container")}>
        <Icon className={cn("map-pin")} iconName={IconNameEnum.mapPin} alt="" />
        <div className={cn("address")}>{text.address}</div>
      </div>
      {children}
    </div>
  );
};
